import { Injectable } from '@angular/core';
import { BackendInvoiseService } from './backend-invoice.service';
import { switchMap, take, tap, map, mapTo, observeOn } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { State, getSegmentsOptions } from '../reducers';
import { Observable, asyncScheduler } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportFileService {
  constructor(private readonly backendInvoiseService: BackendInvoiseService, private readonly store: Store<State>) {}

  loadFile(): Observable<boolean> {
    return this.store.pipe(
      select(getSegmentsOptions),
      switchMap(optionsState => this.backendInvoiseService.getInvoicesReportFile(optionsState.data)),
      map(blob => {
        const link = document.createElement('a');
        link.download = 'report_latam.xls';
        link.rel = 'noopener';
        link.href = URL.createObjectURL(blob);
        link.click();
        return link;
      }),
      observeOn(asyncScheduler),
      tap((link: HTMLAnchorElement) => {
        URL.revokeObjectURL(link.href);
        link.remove();
      }),
      mapTo(true),
      take(1)
    );
  }
}
